import React from 'react';
import ServicePageTemplate from '../../../components/ServicePageTemplate/ServicePageTemplate';
import { getCategoryCatalog } from '../../../adapters/serviceCatalogAdapter';

const LifeEventsPage = ({ onNavigate }) => {
  const catalog = getCategoryCatalog('lifeEvents');

  return (
    <ServicePageTemplate
      serviceType="lifeEvents"
      services={catalog.services}
      filters={catalog.filters}
      pageConfig={catalog.pageConfig}
      onNavigate={onNavigate}
    />
  );
};

export default LifeEventsPage;

